"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _queryString = _interopRequireDefault(require("query-string"));

var _default = {
  /**
   * Removes all the undefined and null properties from an object
   * @param {Object} params
   * @returns {Object} - The object without undefined and nulls properties
   */
  getObjectValues(params) {
    if (!params) {
      return undefined;
    }

    Object.keys(params).forEach(key => !params[key] && delete params[key]);
    return params;
  },

  /**
   * Returns urls with query string by url and params object
   * @param {string} url - The url without the query string
   * @param {Object} params - The params of the url
   * @returns {string} - Url with the query string
   */
  parseUrl(url, params) {
    if (!params) {
      return url;
    }

    const query = this.getObjectValues(params);

    if (Object.keys(query).length === 0) {
      return url;
    }

    return _queryString.default.stringifyUrl({
      url,
      query
    });
  }

};
exports.default = _default;